import { WeatherSettings } from '@fe/weather';
import React from 'react';
import useWeatherService from '../../../../hooks/use-weather-service';

export default function useWeatherSettings() {
    const weatherService = useWeatherService();
    const [settings, setSettings] = React.useState<WeatherSettings | null>(null);

    React.useEffect(() => {
        if (!weatherService) {
            return;
        }
        setSettings(weatherService.getSettings());
        return weatherService.on('settings.changed', () => {
            setSettings({ ...weatherService.getSettings() });
        }).unsubscribe;
    }, [weatherService]);

    return settings;
}
